import { gql } from '@apollo/client';

import {
  V3AddInsightDocument,
  type V3AddInsightMutation,
  type V3AddInsightMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation V3AddInsight($input: AddInsightV2Input!) {
      addInsightV3(input: $input) {
        id
        messages {
          id
          createdAt
          transcript
          sender
          optionRenderType
          text
          contentUrl
          mobileAppEmbedUrl
          mobileAppFileName
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
          metadata {
            isConversationOver
            maxSelections
            options {
              label
              value
              assets {
                id
                name
                url
                description
                createdAt
                updatedAt
              }
            }
            required
            type
            assistantQuestion
            questionId
          }
        }
        contact {
          id
          firstName
          lastName
          email
          phone
        }
        progress
        actions {
          postActivationActionType
          postActivationActionData
          preActivationActionType
          preActivationActionData
        }
      }
    }
  `;
}

export const V3_ADD_INSIGHT = V3AddInsightDocument;
export type { V3AddInsightMutation, V3AddInsightMutationVariables };
